import { Audit, SingleAudit } from 'types/audit_types';
import { PaginatedResponse } from 'types/common_types';
import { createSlice } from '@reduxjs/toolkit';

interface AuditState {
  audit_loading: boolean;
  audits: PaginatedResponse<Audit> | null;
  audit_detail: SingleAudit,
  delete_loading: boolean;
}

const initialState: AuditState = {
  audit_loading: false,
  audits: null,
  audit_detail: null,
  delete_loading: false,
};

export const auditSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuditLoading: (state, action) => {
      state.audit_loading = action.payload;
    },
    setAudits: (state, action) => {
      state.audits = action.payload;
    },
    setAuditDetail: (state, action) => {
      state.audit_detail = action.payload;
    },
    setDeleteLoading: (state, action) => {
      state.delete_loading = action.payload;
    },
  },
});

export const { setAuditLoading, setAudits, setAuditDetail, setDeleteLoading } = auditSlice.actions;

export default auditSlice.reducer;
